import { App, Table, Tag } from 'antd';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import { claimReward, historyPredictions } from 'service/base';
import { AUTH_CHANGED_EVENT } from 'utils/common/authEvents';
import { LocalStorageKey } from 'utils/common/const';
import 'styles/global.css';

function resolveAccount() {
  if (!localStorage.getItem(LocalStorageKey.ACCESS_TOKEN)) {
    return '';
  }
  return (
    localStorage.getItem('saved_account') ||
    localStorage.getItem('userAccount') ||
    ''
  )
    .trim()
    .toLowerCase();
}

export function PredictionHistoryPanel({ IP, FP, className = '' }) {
  const { notification } = App.useApp();
  const [dataPrediction, setDataPrediction] = useState(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
    size: 'default',
    onChange: (page, pageSize) => {
      setPagination((prev) => ({ ...prev, current: page, pageSize }));
    }
  });

  useEffect(() => {
    const total =
      dataPrediction?.totalRecords ??
      (Array.isArray(dataPrediction?.responseData) ? dataPrediction.responseData.length : 0);
    setPagination((prev) => ({ ...prev, total }));
  }, [dataPrediction]);

  const loadHistory = useCallback(async () => {
    const acc = resolveAccount();
    if (!acc) {
      setDataPrediction(null);
      return;
    }
    try {
      setIsLoadingSubmit(true);
      const res = await historyPredictions({
        account: acc,
        site: SITE,
        ip: IP,
        fp: FP
      });
      const payloadData = res?.data || null;
      setDataPrediction(payloadData);
      // const rows = payloadData?.responseData ?? payloadData?.listPrediction;
      // const hasRows = Array.isArray(rows) && rows.length > 0;
      // if (!hasRows) {
      //   notification.warning({
      //     message: 'Không có lịch sử',
      //     description: 'Không tìm thấy lịch sử bình chọn, Quý khách vui lòng kiểm tra lại!'
      //   });
      // }
    } catch {
      setDataPrediction(null);
    } finally {
      setIsLoadingSubmit(false);
    }
  }, [IP, FP]); // eslint-disable-line react-hooks/exhaustive-deps -- notification: tránh vòng lặp khi đưa vào deps

  useEffect(() => {
    loadHistory();
  }, [loadHistory]);

  useEffect(() => {
    const onAuthChanged = () => loadHistory();
    window.addEventListener(AUTH_CHANGED_EVENT, onAuthChanged);
    return () => window.removeEventListener(AUTH_CHANGED_EVENT, onAuthChanged);
  }, [loadHistory]);

  const handleClaimReward = async (item) => {
    if (item.status_register !== 'apply') {
      return;
    }
    try {
      const accountValue = (item.account || resolveAccount() || '').trim().toLowerCase();
      const response = await claimReward({
        account: accountValue,
        site: SITE,
        matchId: item.matchId
      });
      if (response?.code === 0) {
        notification.success({ message: 'Thành công', description: 'Nhận thưởng thành công!' });
        await loadHistory();
      }
    } catch (error) {
      notification.error({
        message: 'Nhận thưởng thất bại!',
        description: error.message
      });
    }
  };

  const columns = [
    {
      title: 'Trận đấu',
      render: (_, record) => `${record.homeName} - ${record.awayName}`
    },
    {
      title: 'Bình chọn',
      width: '15%',
      render: (_, record) => {
        let tagColor = '#000000';
        if (record.status_register === 'deny') {
          tagColor = 'red';
        } else if (record.status_register === 'apply') {
          tagColor = '#0253e0';
        }
        return (
          <Tag className="text-center" color={tagColor} key={record._id}>
            {record.homeScore}-{record.awayScore}
          </Tag>
        );
      }
    },
    {
      title: 'Kết quả',
      width: '15%',
      render: (_, record) => {
        if (record.match_result) {
          return (
            <Tag className="text-center" color="#0253e0" key={record._id}>
              {record.match_result}
            </Tag>
          );
        }
        return null;
      }
    },
    {
      title: 'Ngày dự đoán',
      dataIndex: 'createdAt',
      render: (text) => (text ? dayjs(text).format('DD/MM/YYYY') : '')
    },
    {
      title: 'Nhận thưởng',
      width: '20%',
      render: (_, item) => (
        <div className="flex justify-start">
          <button
            type="button"
            onClick={() => handleClaimReward(item)}
            disabled={item.status_register !== 'apply'}
            className={`px-1 md:px-3 py-2 text-xs md:text-sm rounded-md md:rounded-lg text-white border-none font-semibold ${item.status_register === 'apply' ? 'bg-[#0253e0] cursor-pointer' : 'bg-[#929292] cursor-not-allowed'}`}
          >
            {item.status_register === 'accept' ? 'Đã nhận thưởng' : 'Nhận thưởng'}
          </button>
        </div>
      )
    }
  ];

  const emptyHint = resolveAccount()
    ? 'Chưa có dữ liệu.'
    : 'Vui lòng đăng nhập để xem lịch sử dự đoán tỷ số.';

  return (
    <div className={className}>
      {/*
      <Form name="formHistoryMatch" onFinish={...} form={formHistory} className="relative" autoComplete="off">
        <div className="flex md:justify-center justify-between gap-2 md:py-4 py-1 w-full">
          <div className="relative min-w-[30%] md:min-h-[38px] w-full max-w-[600px] mx-auto md:mx-0">
            <Form.Item name="account" className="mb-0 w-full" rules={[{ required: true, message: 'Vui lòng điền tên đăng nhập!' }]}>
              <Input className="min-h-[38px] w-full pr-[100px] md:pr-[120px]" placeholder="Nhập tên đăng nhập ..." maxLength={30} prefix={<UserOutlined />} autoComplete="username" />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={isLoadingSubmit} className="!bg-[#0253e0] ... absolute right-3 ...">Xác Nhận</Button>
          </div>
        </div>
      </Form>
      */}
      <div className="list-history overflow-x-auto mt-0 md:mt-1">
        <Table
          rowKey={(r) => String(r._id ?? r.matchId ?? `${r.homeName}-${r.awayName}-${r.createdAt}`)}
          size="small"
          columns={columns}
          dataSource={dataPrediction?.responseData || []}
          loading={isLoadingSubmit}
          pagination={pagination}
          locale={{ emptyText: emptyHint }}
        />
      </div>
    </div>
  );
}
